import _ from 'lodash';
import { paginationSize } from '../../../constants/constants';
import {
    FETCH_TYPIST_WORKLOAD_LIST_ERROR,
    FETCH_TYPIST_WORKLOAD_LIST_START,
    FETCH_TYPIST_WORKLOAD_LIST_SUCCESS,
    RESET_TYPIST_WORKLOAD_LIST_FILTER,
    SET_TYPIST_WORKLOAD_LIST_AUTO_NEXT_VISIT,
    SET_TYPIST_WORKLOAD_LIST_FILTER_AND_SORT,
    SET_TYPIST_WORKLOAD_LIST_PAGINATION,
} from '../../actions/typist/typistWorkloadListAction';

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    visits: [],
    searchFilter: {
        searchText: "",
        mipIds: [],
        modalityIds: [],
        risId: 1,
        startDate: null,
        endDate: null,
        radiologist: [],
    },
    sortConditions: [{ sortBy: "priority", dataType: "STRING", sortType: "asc" }],
    autoNextVisit: false,
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    skippedVisits: []
};

const typistWorkloadListReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case SET_TYPIST_WORKLOAD_LIST_FILTER_AND_SORT: {
            return {
                ...state,
                searchFilter: { ...state.searchFilter, ...action.payload.searchFilter },
                sortConditions: action.payload.sortConditions.length > 0 ? [...action.payload.sortConditions] : [],
                skippedVisits: action.payload.skippedVisits.length > 0 ? [...action.payload.skippedVisits] : []
            };
        }
        case FETCH_TYPIST_WORKLOAD_LIST_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_TYPIST_WORKLOAD_LIST_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, visits: action.visits };
        }
        case FETCH_TYPIST_WORKLOAD_LIST_ERROR: {
            return { ...state, error: action.error || '', message: '', loading: false };
        }
        case SET_TYPIST_WORKLOAD_LIST_AUTO_NEXT_VISIT: {
            return { ...state, autoNextVisit: action.autoNextVisit };
        }
        case SET_TYPIST_WORKLOAD_LIST_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }
        case RESET_TYPIST_WORKLOAD_LIST_FILTER: {
            let newState = _.cloneDeep(state);
            newState.searchFilter.searchText = null;
            newState.searchFilter.startDate = null;
            newState.searchFilter.endDate = null;
            newState.searchFilter.radiologist = [];
            return { ...newState };
        }
        default:
            return state;
    }
};

export default typistWorkloadListReducer;
